import { ACDSessionManager } from '@nice-devone/core-sdk';
import { logger } from '../../../utils/logger';
import { clearStaleSession, extractSessionId, persistSessionId } from './session-id.util';

export async function tryJoinExistingSession(
  acdSession: ACDSessionManager,
  agentId: string
): Promise<boolean> {
  try {
    logger.debug('[CXone SDK] Trying to join existing session for agent:', agentId);
    const joinResponse = await acdSession.joinSession({
      agentId: Number(agentId),
    });

    const hasError =
      joinResponse &&
      ('errorCode' in joinResponse ||
        'error' in joinResponse ||
        'error_description' in joinResponse);

    if (joinResponse && !hasError) {
      logger.debug('[CXone SDK] Successfully joined existing session:', joinResponse);
      persistSessionId(acdSession, extractSessionId(joinResponse));
      return true;
    }

    logger.debug('[CXone SDK] Join session returned error, clearing stale session:', joinResponse);
    clearStaleSession(acdSession);
  } catch (joinError) {
    logger.debug('[CXone SDK] No existing session to join, clearing stale session:', joinError);
    clearStaleSession(acdSession);
  }

  return false;
}
